import Oidc from 'oidc-client';

Oidc.Log.logger = console;
Oidc.Log.level = Oidc.Log.NONE;

var port = window.location.port === 80 || window.location.port === 443 ? '' : window.location.port;
var rootUrl = window.location.protocol + '//' + window.location.hostname;
if (port !== '') rootUrl += ':' + port;

var userManager = new Oidc.UserManager({
    userStore: new Oidc.WebStorageStateStore({ store: window.localStorage }),
    authority: process.env.VUE_APP_ID_SERVER_AUTHORITY,
    client_id: 'prismui-js',
    redirect_uri: rootUrl + '/signin-oidc',
    response_type: 'id_token token',
    scope: 'openid profile prism',
    post_logout_redirect_uri: rootUrl,
    silent_redirect_uri: rootUrl + '/silent-renew-oidc',
    accessTokenExpiringNotificationTime: 10,
    automaticSilentRenew: true,
    filterProtocolClaims: true,
    loadUserInfo: true
});

// In Vue 3, globalProperties are set on the app instance in main.js.
// We store a reference so this service can call startSignalR/stopSignalR.
let _globalProperties = null;
export function setGlobalProperties(gp) {
    _globalProperties = gp;
}

userManager.events.addAccessTokenExpired(async function() {
    setTimeout(()=>{
        try {
            if (_globalProperties && _globalProperties.startSignalR) {
                _globalProperties.startSignalR();
            }
        } catch (e) {
            if (_globalProperties && _globalProperties.stopSignalR) {
                _globalProperties.stopSignalR();
            }
        }
    }, 5000);
});

userManager.events.addUserLoaded(async function() {
    setTimeout(()=>{
        try {
            if (_globalProperties && _globalProperties.startSignalR) {
                _globalProperties.startSignalR();
            }
        } catch (e) {
            if (_globalProperties && _globalProperties.stopSignalR) {
                _globalProperties.stopSignalR();
            }
        }
    }, 5000);
});

export default userManager;
